import { vservice } from '@niknevis/vue-modules'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'
import Dialog from 'quasar/src/plugins/Dialog.js';
import DeleteConfirm from '@/modules/common/dialog/components/shared/DeleteConfirm.vue'
import { AdminFaqRoute } from '@/modules/faq/routes/admin-faq.route'
import { FaqRequestModel } from '@/modules/faq/models/faq-request.model'

@vservice()
export class AdminFaqService {
  constructor(
    private readonly routes: AdminFaqRoute
  ) {
  }

  update(id: number, data: FaqRequestModel) {
    return Inertia.put(
      this.routes.update(id),
      data
    )
  }

  store(data: FaqRequestModel) {
    return Inertia.post(
      this.routes.store(),
      data
    )
  }

  destroy(id: number) {
    return Inertia.delete(
      this.routes.destroy(id)
    ).onBeforeAsync(() => new Promise<boolean>((resolve) => {
      Dialog.create({
        component: DeleteConfirm
      }).onOk(() => resolve(true))
        .onCancel(() => resolve(false))
        .onDismiss(() => resolve(false))
    }))
  }
}